import React, {Component} from 'react';
import Helmet from "react-helmet";
import parse from 'html-react-parser';

class MetaStatic extends Component {

  render() {
    let metadata = this.props.metadata ? this.props.metadata : '';

    return (
      <Helmet>
        {parse(metadata)}
      </Helmet>
    );
  }
}

export default MetaStatic;